import { Waypoint, WaypointData, WaypointRaw } from "types/app";
import { decodePolyline, encodePolyline } from "utils/polyline";
import {
  parseLinksArrayToString,
  parseLinksStringToArray,
} from "./linksParser";

export type WaypointSave = Omit<
  WaypointRaw,
  "userId" | "ele" | "createdAt" | "updatedAt" | "localTime"
>;

/** A waypoint to save, `id` -1 for a new one */
export const parseWaypointForAPI = ({
  links,
  id,
  name,
  desc,
  cmt,
  src,
  type,
  icon,
  point,
  visible,
}: WaypointData & { id: number }): WaypointSave => ({
  links: parseLinksArrayToString(links),
  id,
  // Defaults in case a stored waypoint lacks one of the texts
  name: name ?? "",
  desc: desc ?? "",
  cmt: cmt ?? "",
  src: src ?? "",
  type: type ?? "",
  point: encodePolyline([point], 6),
  icon: icon ?? "",
  visible,
});

export const parseWaypointFromAPI = ({
  id,
  name,
  desc,
  links,
  userId,
  cmt,
  src,
  type,
  createdAt,
  ele,
  icon,
  localTime,
  point,
  updatedAt,
  visible,
}: WaypointRaw): Waypoint => ({
  links: parseLinksStringToArray(links),
  id,
  name,
  desc,
  userId,
  cmt,
  src,
  type,
  point: decodePolyline(point)[0],
  ele: ele ? Number(ele) : 0,
  localTime,
  createdAt,
  icon,
  updatedAt,
  visible,
});
